import { Tag } from 'react-tag-autocomplete';
import React from 'react';
import { TagInput } from '../common/TagInput';

// @ts-ignore
export default (onClickHandler, activeIndex, onTagClickHandler, suggestions: Tag[] | []) => {
    return [
        {
            name: 'Company',
            id: 'companyName',
            // @ts-ignore
            selector: row => {
                if(!row.companyName) return row.companyName
                return row.companyName.charAt(0).toUpperCase() + row.companyName.slice(1);
            },
            sortable: true
        },
        {
            name: 'Assessment date',
            id: 'assessmentDate',
            // @ts-ignore
            selector: row => row.assessmentDate,
            // @ts-ignore
            format: row => {
                const dateTimeSplit = row.assessmentDate.split(' ')
                const parts = dateTimeSplit[0].split('-')
                return `${parts[2]}-${parts[1]}-${parts[0]} ${dateTimeSplit[1]}`;
            },
            sortable: true
        },
        {
            name: 'Label',
            id: 'labelTable',
            // @ts-ignore
            selector: row => {
                // @ts-ignore
                return row.tags.map(tag => tag.name.toLowerCase()).join('')
            },
            // @ts-ignore
            format: row => {
                // @ts-ignore
                return row.tags.map(tag => tag.name).join(', ')
            },
            sortable: true,
            // @ts-ignore
            cell: (row, index) => {
                return <TagInput
                    rowIndex={index}
                    currentActiveRowIndex={activeIndex}
                    setCurrentActiveRowIndex={onTagClickHandler}
                    suggestions={suggestions}
                    entityId={row.id}
                    type={'ASSESSMENT'}
                    row={row}
                />
            }
        },
    ];
}
